import { render, staticRenderFns } from "./tnc-popup.vue?vue&type=template&id=174053fd&scoped=true&"
import script from "./tnc-popup.vue?vue&type=script&lang=js&"
export * from "./tnc-popup.vue?vue&type=script&lang=js&"
import style0 from "./tnc-popup.vue?vue&type=style&index=0&id=174053fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174053fd",
  null
  
)

export default component.exports